import { createApp } from 'vue'
import ConsentFormDetail from '../components/consents/ConsentFormDetail.vue';
import ConsentDetail from '../components/consents/ConsentDetail.vue';
import ConsentFields from '../components/surveys/ConsentFields.vue';

// Consent detail
if (document.getElementById('consent-detail')) {
  const consentDetail = createApp({})
  consentDetail.component('ConsentDetail', ConsentDetail)
  consentDetail.mount('#consent-detail')
}

// Consent Form detail
if (document.getElementById('consent-form-detail-container')) {
  const consentFormDetail = createApp({})
  consentFormDetail.component('ConsentFormDetail', ConsentFormDetail)
  consentFormDetail.mount('#consent-form-detail-container')
}

// Consent fields
if (document.getElementById('consent-fields-container')) {
  const consentFields = createApp({})
  consentFields.component('ConsentFields', ConsentFields)
  consentFields.mount('#consent-fields-container')
  
  var form = $('#consents').parents('form');
  form.on('submit', function(evt) {
    consentFields.$refs.consents.addConsent();
  })
}